import { observable, action } from 'mobx'
import { riskRequest } from '../../requests/riskRequest'

class RiskUnitStore {
  @observable units = {
    NDDPV: [],
    DVPT: [],
    CQVP: [],
    ALL: [],
  }

  @observable selectedUnits = {
    tier3: [],
  }

  @action async getDVPTUnits() {
    const { data: riskUnits } = await riskRequest.getRiskUnitsV2('DVPT')
    this.units['DVPT'] = riskUnits
  }
}

export default new RiskUnitStore()
